import { IHttpApi } from '@cian/http-api/shared';

import {
  fetchGetComparisonDesktop,
  TGetComparisonDesktopResponse,
} from '../../repositories/offers-comparison/v2/get-comparison-desktop';
import { prepareComparison } from '../../mappers/comparison/prepareComparison';
import { TCompareType } from '../../types/compareType';
import { assertNotFoundError } from './assert';
import type { ICompare } from './service';

interface IParameters {
  compareType: TCompareType;
}

export interface IFetchComparison {
  httpApi: IHttpApi;
  parameters: IParameters;
}

export async function fetchComparison({ httpApi, parameters }: IFetchComparison): Promise<ICompare> {
  const response: TGetComparisonDesktopResponse = await fetchGetComparisonDesktop({
    httpApi,
    parameters: {
      onlyDifferences: parameters.compareType === 'differences',
    },
  });

  assertNotFoundError(response);

  return prepareComparison({
    response: response.response,
    compareType: parameters.compareType,
  });
}
